<template>
    <div class="thanks">
        <div class="wrapper">
            <h2 class="title">Спасибо!</h2>
            <div class="separator"></div>
            <div class="notice">Ваша идея появится в общем списке после модерации</div>
            <div class="button-to-ideas">
                <router-link :to="{ name: 'ideas' }" class="button">Смотреть все идеи</router-link>
            </div>
            <div class="button-to-idea-create">
                <router-link :to="{ name: 'idea-create' }" class="link">Добавить ещё идею</router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Thanks'
    }
</script>


// WEBPACK FOOTER //
// Thanks.vue?9d84df00